@if (data.marginTopEnableWithBreadCrump==1) {
<div>
  <div [ngClass]="{'margin-t10': this.data.enableBreadcrumbPages === 0, '': this.data.enableBreadcrumbPages !== 0}">
  </div>
</div>
}


<div>
  <div>
    <div fxFlex.xs="100" [fxFlex]="data.layout!='twentyseven'?100:80">
      @for (item of homePageProduct;let i=$index; track item.layoutConfigId) {
      <div>
        <div [ngClass]="i>0 ? 'margin-t10' : ''">
          @if (item?.type == 'vedioBanner') {
          <div>
            <calsoft-video-banner-search [item]="item" [img]="item.images" [data]="data"></calsoft-video-banner-search>
          </div>
          }
          @if (item.type=='ScrollWithTextAndImage' && item?.customField10=='Type 1') {
          <div [ngClass]="i>0 ? 'margin-t11' : ''">
            <calsoft-animated-scroll [data]="data" [item]="item" [images]="item.images"></calsoft-animated-scroll>
          </div>
          }
          @if (item.type=='ScrollWithTextAndImage' && item?.customField10=='Type 3') {
          <div [ngClass]="i>0 ? 'margin-t11' : ''">
            <calsoft-animated-scroll [data]="data" [item]="item" [images]="item.images"></calsoft-animated-scroll>
          </div>
          }
          @if (item.type=='ScrollWithTextAndAnimatedImage') {
          <div>
            <calsoft-animate-scroll-two [data]="data" [item]="item" [images]="item.images"></calsoft-animate-scroll-two>
          </div>
          }
          @if (item?.type=='ScrollWithAnimatedReview') {
          <div>
            <calsoft-animated-scroll-review [data]="data" [item]="item"
              [images]="item.images"></calsoft-animated-scroll-review>
          </div>
          }
          @if (item.type=='bannerTextWithButton') {
          <ng-container style="display: contents;">
            <div [class.space]="item.customField8.length>0" [ngClass]="i>0 ? 'margin-t11' : ''" class="bg-image"
              [style.backgroundImage]="'url(' + serverPath+item.customField6 + ')'"
              [style.background-color]="item.customField8">
              <div [ngClass]="i>0 ? 'margin-t11' : ''"
                [class.container]="item.customField1 !== 'type3' && item.customField1 !== 'type4'" class="container">
                <calsoft-banner-over-content [item]="item" [data]="data" [img]="item.images">
                </calsoft-banner-over-content>
              </div>
            </div>
          </ng-container>
          }
          @if (item.type=='tabLayout') {
          <div [ngClass]="i>0 ? 'margin-t11' : ''">
            <div [class.space]="item.customField8.length>0" class="bg-image"
              [style.backgroundImage]="'url(' + serverPath+item.customField6 + ')'"
              [style.background-color]="item.customField8">
              <div class="container">
                <calsoft-tab-layout [data]="data" [item]="item" [heightMobile]="productImageHeightMob"
                  [widthMobile]="productImageWidthMob" [height]="productImageHeight" [width]="productImageWidth"
                  [imageType]="productImageType" [showConfigurableDropdown]="showConfigurableDropdown"
                  [showCartIcon]="showCartIcon" [showCartIncremented]="showCartIncremented"
                  [other]="item.type=='carouselwithProduct'?'productScope':'other'" [id]="item.customField1"
                  [slidesPerView]="item?.customField29" [sortOrder]="item.sortOrder" [header]="item.title" [item]="item"
                  [img]="item?.images">
                </calsoft-tab-layout>
                <!-- @if (item.customField13==8) {
                <calsoft-tablayout2 [data]="data" [item]="item" [heightMobile]="productImageHeightMob"
                  [widthMobile]="productImageWidthMob" [height]="productImageHeight" [width]="productImageWidth"
                  [imageType]="productImageType" [showConfigurableDropdown]="showConfigurableDropdown"
                  [showCartIcon]="showCartIcon" [showCartIncremented]="showCartIncremented"
                  [other]="item.type=='carouselwithProduct'?'productScope':'other'" [id]="item.customField1"
                  [sortOrder]="item.sortOrder" [header]="item.title" [slidesPerView]="item.customField29" [item]="item"
                  [img]="item.images">
                </calsoft-tablayout2>
                } -->
              </div>
            </div>
          </div>
          }
          @if (item.type=='iconTextWithBackground') {
          <div [ngClass]="i>0 ? 'margin-t11' : ''">
            <div [class.container]="item.customField23 !== '1'" class="container">
              <calsoft-new-banner [data]="data" [item]="item" [img]="item.images"></calsoft-new-banner>
            </div>
          </div>
          }
          @if (item.type=='DoubleImagescroll') {
          <div [ngClass]="i>0 ? 'margin-t11' : ''">
            <calsoft-doubleimageform [data]="data" [item]="item"></calsoft-doubleimageform>
          </div>
          }
          @if (item.type=='blogData') {
          <div [ngClass]="i>0 ? 'margin-t11' : ''">
            <div [class.container]="item.layout !== '1'" class="container">
              <calsoft-blog-section [data]="data"></calsoft-blog-section>
            </div>
          </div>
          }
          @if (item.type=='textWithText') {
          <div [ngClass]="i>0 ? 'margin-t11' : ''">
            <div [class.space]="item.customField8.length>0" [style.background-color]="item.customField8">
              <div class="container">
                <calsoft-text-with-text [data]="data" [item]="item" [img]="item.images">
                </calsoft-text-with-text>
              </div>
            </div>
          </div>
          }
          @if (item.type=='table' && (item.customField33=='2' || item.customField33=='4' || item.customField33=='13') )
          {
          <div [ngClass]="i>0 ? 'margin-t11' : ''" fxFlex="100">
            <div class="container">
              <calsoft-plan-compare fxFlex="100" [item]="item"></calsoft-plan-compare>
            </div>
          </div>
          }
          @if (item.type=='buttonType' && (item.customField15=='1' || item.customField15=='3' || item.customField15=='5'
          ||
          item.customField15=='7'
          )) {
          <div>
            <calsoft-button-row-header [data]="data" [item]="item"></calsoft-button-row-header>
          </div>
          }
          @if (item.type=='ScrollWithTextAndImage' && item?.customField10=='Type 2') {
          <div [ngClass]="i>0 ? 'margin-t11' : ''">
            <calsoft-zigzagimage1 [data]="data" [item]="item" [images]="item.images"></calsoft-zigzagimage1>
          </div>
          }
          @if ((item.type=='textWithImage' && item.customField20!='5') &&router.url!='/blog') {
          <div class=" outer-wrapper background-wrapper" [ngStyle.gt-md]="{'margin-bottom': '5rem'}"
            [style.background-color]="item.customField27">
            <div class=" outer-wrapper background-wrapper">
              <div [class.space]="item.customField8.length>0" [ngClass]="{'margin-t10': i > 0}"
                [class.container]="item.customField20 !== '2' && item.customField20 !== '3' && item.customField20 !== '4'"
                class="container inner-wrapper" fxLayout.lt-md="column" [style.color]="item.customField28"
                [fxLayout.gt-md]="item.customField3=='right'?'row':'row-reverse'" [fxLayoutGap]="item.gapBetweenImage">
                <div fxFlex.gt-md="50" fxFlex.lt-md fxLayout="row" [style.align-items]="item.customField30 || 'center'">
                  <div style="width:100%; word-break: break-all;" [ngClass]="{'container': item.customField20 === '4'}"
                    fxLayoutGap="5px">
                    @if (item.images[0].customField33 != 2) {
                    <div>
                      @if (item.customField20==1 || item.customField20 == '3') {
                      <div fxLayout="row" fxLayoutAlign="start center">
                        <calsoft-textwithimage [item]="item" [data]="data">
                        </calsoft-textwithimage>
                      </div>
                      }
                      @if (stripHtmlTags(item?.title) != '') {
                      <span>
                        @if (item.customField20 == 0 || item.customField20 == '2' || item.customField20 == '4') {
                        <div fxLayout="row" fxLayoutAlign="start center">
                          <div class="textwithImage" style="word-break: break-word;" [style.color]="item.customField28"
                            [ngStyle]="{'font-family': item.fontFamily}">

                            <calsoft-editor-text [data]="data" [id]="item.customField35"
                              [ngStyle.gt-md]="{'font-size': item.customField18 }" [ngStyle.lt-md]="{
                                                          
                                                          'font-size': item.customField17
                                                      }" [text]="item?.title" [align]="item.customField34">
                            </calsoft-editor-text>
                          </div>
                        </div>
                        }
                      </span>
                      }
                    </div>
                    }
                    <div style="width:100% ;" fxLayoutGap="10px"
                      [ngStyle]="{'font-family': item.fontFamily || 'Poppins,sans-serif!important'}">

                      <div>

                        <calsoft-editor-text [data]="data" [matIcon]="item.customField4"
                          [ngStyle.gt-md]="{'font-size': item.customField37 }" [ngStyle.lt-md]="{
                                                  
                                                  'font-size': item.customField38
                                              }" [text]="item?.customField1"
                          [ngStyle]="{'font-family': item.fontFamily || 'Poppins,sans-serif!important'}"
                          [align]="item.customField34" [id]="item.customField35">
                        </calsoft-editor-text>
                      </div>

                      @if (item.images[0].customField26==1) {
                      <div>
                        <!-- display in the first row of the table as headers -->
                        <!--<table style="width:100%; border-collapse: collapse;">
                        <thead>
                          <tr style="background-color: #f3f3f3;">
                            <th *ngFor="let field of item.images[0].customField22.split(',')" style="padding: 10px; text-align: left; border: 1px solid #ddd;">
                              <strong>{{ field }}</strong>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td *ngFor="let data of item.images[0].customField24.split(','); let i = index" style="padding: 10px; text-align: left; border: 1px solid #ddd;">
                              {{ data }}
                            </td>
                          </tr>
                        </tbody>
                      </table> -->
                        <!-- data to display in two columns -->
                        <table style="width:100%; border-collapse: collapse;">
                          <tbody>
                            <!-- Iterate over fields and data to display in two columns -->
                            @for (field of item.images[0].customField22.split(','); track field; let i = $index) {
                            <tr>
                              <td
                                style="padding: 10px; text-align: left; border: 1px solid #ddd; background-color: #f3f3f3;">
                                <strong>
                                  <calsoft-editor-text [data]="data" [matIcon]="item.customField4"
                                    [ngStyle.gt-md]="{'font-size': item.customField37}"
                                    [ngStyle.lt-md]="{'font-size': item.customField38}" [text]="field"
                                    [ngStyle]="{'font-family': item.fontFamily || 'Poppins, sans-serif!important'}"
                                    [align]="item.customField34" [id]="item.customField35">
                                  </calsoft-editor-text>
                                </strong>
                              </td>
                              <td style="padding: 10px; text-align: left; border: 1px solid #ddd;">
                                <calsoft-editor-text [data]="data" [matIcon]="item.customField4"
                                  [ngStyle.gt-md]="{'font-size': item.customField37}"
                                  [ngStyle.lt-md]="{'font-size': item.customField38}"
                                  [text]="item.images[0].customField24.split(',')[i]"
                                  [ngStyle]="{'font-family': item.fontFamily || 'Poppins, sans-serif!important'}"
                                  [align]="item.customField34" [id]="item.customField35">
                                </calsoft-editor-text>
                              </td>
                            </tr>

                            }
                          </tbody>
                        </table>
                      </div>
                      }
                    </div>
                    @if (item.images[0].customField33 != 1 && item.images[0].customField33 != 2) {

                    <div fxLayout="row">

                      @if (item.categoryId6==0 && item.customField5.length > 0) {
                      <button style="color: white;margin-top: 15px" [style.border-radius]="item.customField11"
                        (click)="goToCategories(item.customField2)" mat-flat-button
                        class="primary">{{item.customField5}}</button>
                      }
                      @if (item.categoryId6==1 && item.customField5.length > 0) {
                      <button style="color: white;margin-top: 15px" [style.border-radius]="item.customField11"
                        (click)="link(item.customField2)" mat-flat-button class="primary">{{item.customField5}}</button>
                      }
                      @if (item.categoryId6==2 && item.customField5.length > 0) {
                      <button style="color: white;margin-top: 15px" [style.border-radius]="item.customField11"
                        (click)="dynamicFormPopup(item.customField2)" mat-flat-button
                        class="primary">{{item.customField5}}</button>
                      }
                    </div>
                    }
                    @if (item.images[0].customField33 == '1') {
                    <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 20px;">
                      @if (item.categoryId6==0 && item.customField5.length > 0 ) {

                      <button style="color: white;margin-top: 15px" [style.border-radius]="item.customField11"
                        [style.background-color]="item.images[0].customField18"
                        (click)="goToCategories(item.customField2)" mat-flat-button
                        [style.padding-left]="item.images[0].customField20"
                        [style.padding-right]="item.images[0].customField20"
                        [style.height]="item.images[0].customField17" class="primary">{{item.customField5}}</button>
                      }
                      @if (item.categoryId6==1 && item.customField5.length > 0) {
                      <button style="color: white;margin-top: 15px" [style.border-radius]="item.customField11"
                        [style.padding-left]="item.images[0].customField20"
                        [style.padding-right]="item.images[0].customField20" (click)="link(item.customField2)"
                        [style.background-color]="item.images[0].customField18" mat-flat-button class="primary"
                        [style.height]="item.images[0].customField17">{{item.customField5}}</button>
                      }
                      @if (item.categoryId6==0 && item.images[0].customField16.length > 0) {
                      <button style="color: white;margin-top: 15px" [style.border-radius]="item.customField11"
                        [style.height]="item.images[0].customField17"
                        (click)="openInNewWindow(item.images[0].customField22)" mat-flat-button
                        [style.background-color]="item.images[0].customField19"
                        [style.padding-left]="item.images[0].customField20"
                        [style.padding-right]="item.images[0].customField20"
                        class="primary">{{item.images[0].customField16}}</button>
                      }
                      @if (item.categoryId6==1 && item.images[0].customField16.length > 0 ) {
                      <button style="color: white;margin-top: 15px" [style.border-radius]="item.customField11"
                        [style.padding-left]="item.images[0].customField20"
                        [style.padding-right]="item.images[0].customField20"
                        (click)="openInNewWindow(item.images[0].customField22)"
                        [style.background-color]="item.images[0].customField19" mat-flat-button class="primary"
                        [style.height]="item.images[0].customField17">{{item.images[0].customField16}}</button>
                      }
                    </div>
                    }
                    <div>
                    </div>
                  </div>
                </div>
                <!-- //| slice:0:1 you need to change -->
                @for (img of item.images ; track img; let l = $index) {
                <div class="images" fxFlex.gt-md="50" fxFlex.lt-md fxLayout="column" fxLayoutAlign="start stretch">
                  @if (img?.type==2) {
                  <div>
                    <div style="width: 100%;height:500px" ngStyle.lt-md="height:100%">
                      <iframe style="width: 100%; height: 100%;"
                        [src]="youtubeUrl+img?.img | safe: 'resourceUrl'"></iframe>
                    </div>
                  </div>
                  }
                  @if (img?.type==1) {
                  <div contentAnim [aniName]="item.customField36" [ngClass]="{'cardzoom': img?.customField9 === '1'}">
                    <!-- <img style="width:100% ;" [style.height]="item.height"
                    [style.margin-right]="item.gapBetweenImage"
                    [ngClass]="{'container': item.customField20 === '4'}"
                    [ngStyle.lt-md]="{'height': item.heightMob}"
                    (click)="img.navigation==0?goToCategories(img.catId):link(img.navigatedUrl)"
                    [src]="serverPath+img.img" [alt]="img.altImage || 'images' "> -->
                    <img style="width: 100%;" [style.height]="item.height" [ngStyle.lt-md]="{
                      'height': item.heightMob,
                      'margin-right': null
                    }" [ngStyle.gt-md]="{
                      'height': item.heightMob,
                      'margin-right': item.gapBetweenImage
                    }" (click)="img?.navigation == 0 ? goToCategories(img?.catId) : link(img?.navigatedUrl)"
                      [src]="serverPath + img?.img" [alt]="img?.altImage || 'images'" />

                  </div>
                  }
                </div>
                }
              </div>
              @if (img?.customField10==1) {
              <div class="container program-overview" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="32px">
                <h2 style="color: white;">{{item.customField19}}</h2>

                <div fxFlex="100" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center"
                  fxLayoutAlign.xs="space-between start" fxLayoutGap="20px" style="width: 100%;">

                  <!-- Card 1 -->
                  <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="8px">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                      <mat-icon class="program-icon">{{img.customField14}}</mat-icon>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
                      <h3>{{img.customField15}}</h3>
                      <p class="program-text">{{img.customField16}}</p>
                    </div>

                  </div>

                  <!-- Card 2 -->

                  <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="8px">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                      <mat-icon class="program-icon">{{img.customField17}}</mat-icon>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
                      <h3>{{img.customField18}}</h3>
                      <p class="program-text">{{img.customField19}}</p>
                    </div>

                  </div>

                  <!-- Card 3 -->
                  <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="8px">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                      <mat-icon class="program-icon">{{img.customField20}}</mat-icon>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
                      <h3>{{img.customField21}}</h3>
                      <p class="program-text">{{img.customField23}}</p>
                    </div>

                  </div>
                </div>
              </div>
              }
            </div>
          </div>
          }
          @if (item.type=='footer') {
          <div [ngClass]="i>0 ? 'margin-t11' : ''">
            <calsoft-footerlayout [item]="item" [data]="data" [img]="item.images"></calsoft-footerlayout>
          </div>
          }
          @if (item.type=='scrolltextwithform') {
          <div [ngClass]="{'margin-t10': i > 0, 'scroll-bg': item.customField9 && item.customField9.length > 0}"
            [style.backgroundImage]="'url(' + serverPath+item.customField9 + ')'"
            [ngStyle.gt-md]="{'height': item.customField32}" [style.background-color]="item.customField8">
            <div class="container">
              <div [fxLayout.gt-md]="item.customField3=='left'?'row':'row-reverse'" fxLayout.xs="column">
                <div [fxFlex]="item.customField2!=undefined?item.customField2:'70'" fxFlex.xs="100"
                  [style.margin-top]="item.gapBetweenImage">

                  <div fxLayout="column" style="height: 100%;"
                    [fxLayoutAlign]="item.customField21.length > 0 ? '' : item.customField36"
                    [ngStyle]="item.customField21.length > 0 ? { 'height': 'auto' } : { 'height': '100%' }">
                    <div fxLayout="row" fxLayoutAlign="start center">
                      <div [style.color]="item.customField33" class="newhead" style="margin-bottom: 10px;">
                        <calsoft-editor-text [data]="data" [text]="item.customField6" [align]="item.customField34"
                          [style.font-size]="item.customField37" [ngStyle.lt-md]="{ 'font-size': item.customField38 }"
                          style="line-height: 3.5rem;">
                        </calsoft-editor-text>
                      </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center">
                      <div [style.color]="item.customField33" class="subpage">
                        <calsoft-editor-text [data]="data" [text]="item.customField7" [align]="item.customField34"
                          [style.font-size]="item.customField35" [ngStyle.lt-md]="{ 'font-size': item.customField34 }">
                        </calsoft-editor-text>
                      </div>
                    </div>

                    <div fxLayout.xs="column" class="button-container" fxLayoutGap.lt-md="10px">
                      <button class="primary-btn" (click)="navigateToGetStarted()">Get Started</button>
                      <button class="outline-btn" (click)="navigateToConnect()">Connect with Us</button>
                    </div>

                  </div>
                  @if (item.customField21.length>0) {
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <img [style.width]="item.height" onerror="" [style.height]="item.height"
                      [ngStyle.lt-md]="{'height': item.heightMob}" [ngStyle.lt-md]="{'width': item.heightMob}"
                      [src]="serverPath+item.customField21" />
                  </div>
                  }
                  @if (item.customField29 === '0') {
                  <div style="margin: 20px 0;">
                    @if (item.customField14.length>0) {
                    <button (click)="TextwithFormPopup(item)" [disabled]="item.isButtonDisabled"
                      [style.padding]="'10px 20px'" [style.font-size]="'16px'" [style.color]="'#fff'" class="primary"
                      [style.border]="'none'" [style.border-radius]="'5px'"
                      [style.box-shadow]="'0 4px 6px rgba(0, 0, 0, 0.1)'" [style.cursor]="'pointer'"
                      [style.opacity]="item.isButtonDisabled ? '0.6' : '1'" [style.transition]="'all 0.3s ease-in-out'"
                      [style.transform]="'translateY(0)'" (mouseenter)="hovering = true" (mouseleave)="hovering = false"
                      [style.transform]="hovering && !item.isButtonDisabled ? 'translateY(-2px)' : 'translateY(0)'">
                      {{item.customField14}}
                    </button>
                    }
                  </div>
                  }
                  @if (item.layout!=0) {
                  <div>
                    <owl-carousel-o [options]="LogoSlider">
                      @for (img of item.images; track img; let l = $index) {
                      <ng-template carouselSlide>
                        <div class="slide" width="100%" fxLayoutAlign="center center">
                          <img width="100%" fxLayoutAlign="center center" [style.height]="item.customField11"
                            [ngStyle.lt-md]="{'height': item.customField12}" [src]="serverPath1+img.img" />
                        </div>
                      </ng-template>
                      }
                    </owl-carousel-o>
                  </div>
                  }
                </div>
                @if (item.customField3!='left') {
                <div fxFlex="5">
                </div>
                }
                @if (!item.customField9 || item.customField9.length === 0) {
                <span style="border-right: 1px solid lightgray; padding: 25px "></span>
                }
                @if (item.customField3=='left' && item.customField21.length!=0) {
                <div fxFlex="5">
                </div>
                }
                <!-- <div  [ngClass.lt-md]="'margin-t10'" [fxFlex]="item.customField2!=undefined?100-item.customField2:'30'" fxFlex.xs="100"
              [ngStyle.gt-md]="{'margin-top': item.gapBetweenImage, 'margin-bottom': '20px'}"
              fxLayoutAlign="end center"> -->
                <div [ngClass.lt-md]="'margin-t10'" [fxFlex]="item.customField2!=undefined?100-item.customField2:'30'"
                  fxFlex.xs="100" [ngStyle]="{'margin-top': item.gapBetweenImage, 'margin-bottom': '20px'}"
                  [ngStyle.lt-md]="{'margin-top': '20px', 'margin-bottom': '20px'}">
                  {{item.customField35}}
                  <calsoft-contact-form [id]="item.customField35" [data]="data" [item]="item" [input]="item.title">
                  </calsoft-contact-form>
                </div>
              </div>
              @if (item.layout==0) {
              <div>
                <div fxLayoutAlign="center center" class="title">
                  <div style="color: white;">
                    <calsoft-editor-text [data]="data" [text]="item.customField4" [align]="item.customField34"
                      [ngStyle.gt-md]="{'font-size': item.customField39 }"
                      [ngStyle.lt-md]="{'font-size': item.customField40}">
                    </calsoft-editor-text>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
          }
          @if (item.images.length>0) {
          <div>
            @if (item.type=='brandsCarousel' && item.customField23!== '8' && item.customField23!== '26' &&
            item.customField23!== '13' && item.customField23!== '29' ) {
            <div [ngClass]="i>0 ? 'margin-t11' : ''">
              <div [class.container]="item.customField23!== '6' && item.customField23!== '11'
                  
                   && item.customField23!== '12'&& item.customField23!== '22' "
                [style.background-color]="item.customField8" style="background-size: cover;"
                [style.backgroundImage]="'url(' + serverPath+item.customField6 + ')'"
                [style.border-radius]="item.customField23 ? '10px' : '0px'">
                <calsoft-brands [data]="data" [item]="item" [brands]="item.images"></calsoft-brands>
              </div>
            </div>
            }
            @if (item.type=='brandsCarousel' && item.customField23== '8') {
            <div>
              <!-- <calsoft-carousel-slide [data]="data" [img]="item.images" [item]="item"></calsoft-carousel-slide> -->
            </div>
            }
            @if (item.type=='brandsCarousel' && item.customField23== '26') {
            <div>
              <!-- <calsoft-brands-carousel-type26 [img]="item.images" [data]="data" [item]="item">
            </calsoft-brands-carousel-type26> -->
            </div>
            }
            @if (item.type=='brandsCarousel' && item.customField23== '29') {
            <div>
              <calsoft-brands [data]="data" [item]="item" [brands]="item.images"></calsoft-brands>
            </div>
            }

            @if (item.type=='brandsCarousel' && item.customField23== '13') {
            <div [ngClass]="i>0 ? 'margin-t11' : ''">
              <calsoft-brands [data]="data" [item]="item" [brands]="item.images"></calsoft-brands>
            </div>
            }
            @if (item.type=='brandsCarousel' && item.customField23== '15') {
            <div>
              <!-- <calsoft-banner-anime [img]="item.images" [data]="data" [item]="item"></calsoft-banner-anime> -->
            </div>
            }
            @if (item.type=='brandsCarousel' && item.customField23== '16') {
            <div>
              <!-- <calsoft-imagescrolling [img]="item.images" [data]="data" [item]="item">
            </calsoft-imagescrolling> -->
            </div>
            }
            @if (item.type=='brandsCarousel' && item.customField23== '17') {
            <div>
              <!-- <calsoft-image-item-list [img]="item.images" [data]="data" [item]="item">
            </calsoft-image-item-list> -->
            </div>
            }
            @if (item.type=='brandsCarousel' && item.customField23== '18') {
            <div>
              <div class="container">
                <!-- <calsoft-anime-image fxFlex="100" [img]="item.images" [data]="data" [item]="item">
              </calsoft-anime-image> -->
              </div>
            </div>
            }
            @if (item.type=='brandsCarousel' && item.customField23== '19') {
            <div>
              <div class="container">
                <!-- <calsoft-faciliteis-image fxFlex="100" [img]="item.images" [data]="data" [item]="item">
              </calsoft-faciliteis-image> -->
              </div>
            </div>
            }
            @if (item.type=='brandsCarousel' && item.customField23== '20') {
            <div>
              <div class="container">
                <!-- <calsoft-image-checkbox fxFlex="100" [img]="item.images" [data]="data" [item]="item">
              </calsoft-image-checkbox> -->
              </div>
            </div>
            }
            @if (item.type=='brandsCarousel' && item.customField23== '23') {
            <div>
              <div class="container">
                <!-- <calsoft-bannerimage-text2 fxFlex="100" [img]="item.images" [data]="data" [item]="item">
              </calsoft-bannerimage-text2> -->
              </div>
            </div>
            }
            @if (item.type=='brandsCarousel' && item.customField23== '24') {
            <div>
              <div [style.backgroundImage]="'url(' + serverPath+item.customField6 + ')'">
                <div style="background-color: rgba(10, 15, 28, 0.7);">
                  <div class="container">
                    <!-- <calsoft-pyramidimage fxFlex="100" [img]="item.images" [data]="data" [item]="item">
                  </calsoft-pyramidimage> -->
                  </div>
                </div>
              </div>
            </div>
            }
            @if (item.type=='brandsCarousel' && item.customField23== '28') {
            <div>
              <calsoft-brandscarousel-type27 fxFlex="100" [img]="item.images" [data]="data" [item]="item">
              </calsoft-brandscarousel-type27>
            </div>
            }
          </div>
          }

          @if (item.type=='image' && item.customField10 !== 'Type 11' ) {
          <div class="bg-image">
            <div [style.padding-top]="item.customField35" [id]="item.id" [style.background-color]="item.customField8"
              [fxLayoutGap]="item.mobileGapBetweenImage">
              @if (item.customField5) {
              <span class="imgtitle">

                <calsoft-editor-text [data]="data" [text]="item?.customField5" [style.color]="item.customField22"
                  [ngStyle.gt-md]="{'font-size': item.customField18 }" [ngStyle.lt-md]="{
                          
                          'font-size': item.customField17
                      }">
                </calsoft-editor-text>
              </span>
              }
              <div class="bg-image" [style.backgroundImage]="'url(' + serverPath+item.customField6 + ')'"
                [style.background-color]="item.customField8">
                <div [class.container]="!shouldHideContainer() || item?.layout != 1"
                 [ngClass]="item.customField10=='type1' ? '' : 'sas1'"
                  [fxLayout]="item.customField10 == 'Type 10' ? 'row' : 'row wrap'" fxFlex="100">
                  @for (img of item.images; track img; let i = $index) {
                  <div [ngStyle]="{ 'margin-right':item.images.length-1==i?'0px':item.gapBetweenImage}" [ngStyle.lt-md]="{
                  'margin-right': (item.images.length-1==i?'0px':item.displayMobileImage === 1 || 
                                   (item.displayMobileImage === 3 && i > 1)) ? '0px' : item.mobileGapBetweenImage
                }" [fxFlex]="item.layout === 2 ? '100%' : 'auto'" [fxFlex]="item.layout == 2 ? 
             (item.gapBetweenImage ?  'calc(50% - ' + item.gapBetweenImage + ')' : '50%') 
             : (item.layout == 3 ? (item.gapBetweenImage ? 'calc(33.33% - ' + item.gapBetweenImage + ')' : '33.33%') 
               : (item.layout == 4 ? (item.gapBetweenImage ? 'calc(25% - ' + item.gapBetweenImage + ')' : '25%') 
                 : '100'))" [fxFlex.lt-md]="item.displayMobileImage == 2 ? (item.mobileGapBetweenImage ? 'calc(50% - ' + item.mobileGapBetweenImage + ')' : '50%')
                 : (item.displayMobileImage == 3 ? (item.mobileGapBetweenImage ? 'calc(33.33% - ' + item.mobileGapBetweenImage + ')' : '33.33%')
                   : (item.displayMobileImage == 4 ? (item.mobileGapBetweenImage ? 'calc(25% - ' + item.mobileGapBetweenImage + ')' : '25%')
                     : '100'))" [ngClass]="{
                            'margin-t10': !(shouldHideContainer() && (item?.layout == 1 || item?.layout == '1')),
                            'images': true
                          }">
                    @if (img.type==2) {
                    <div fxLayoutAlign="center center">
                      <div [style.height]="item.height" [ngStyle.lt-md]="{
            'padding-top': i > 0 ? item.categoryId6 == 1 ? '10px' : 
            i == 0 ? '10px' : '0px' : '0px',
            'height': item.heightMob
             }" fxLayout="row">
                        <div style="height:100%;" [style.width]="img.customField22 ? img.customField22 : '100%'"
                          [ngStyle.lt-md]="{ 'width': img.customField24}" [ngStyle.lt-md]="{'width':'100%'}">
                          @if (img.autoplay == 1) {
                          <span>
                            <iframe oncanplay="this.play()" style="width: 100%; height: 100%"
                              [src]="youtubeUrl + img.img + '?autoplay=1' | safe: 'resourceUrl'" frameborder="0"
                              allow="autoplay">
                            </iframe>
                          </span>
                          }
                          @if (img.autoplay == 0) {
                          <span>
                            <iframe style="width: 100%; height: 100%"
                              [src]="youtubeUrl + img.img | safe: 'resourceUrl'">
                            </iframe>
                          </span>
                          }
                        </div>
                      </div>
                    </div>
                    }
                    @if (img.type==1 && item?.customField10 !== 'Type 3' && item?.customField10 !== 'Type 4' &&
                    item?.customField10 != 'Type 6' && item?.customField10 != 'Type 8' && item?.customField10 != 'Type
                    9' &&
                    item?.customField10 != 'Type 10') {
                    <div fxLayoutAlign="center center">
                      <div fxFlex contentAnim [aniName]="img.customField7"
                        [ngClass]="{'border':item.customField10=='Type 2', 'collection-banner': item.customField9==1}"
                        class="fast">
                        <div fxLayout="column" [ngClass]="item.customField10== 'Type 7' ? 'image-container' : ''">
                          <div class="pointer" fxLayout="column">
                            <img width="100%" [style.height]="item.height" [ngStyle.lt-md]="{
                      'padding-top': i > 0 ? item.categoryId6 == 1 ? '10px' : 
                      i == 0 ? '10px' : '0px' : '0px',
                      'height': item.heightMob
                  }" [ngClass]="item.customField9==2 ? '' : 'collection-banner '" fxLayoutAlign="space-evenly stretch"
                              (click)="(img.navigation == 0) ? imageNavigation(img.catId) 
                                                  : (img.navigation == 1) ? link(img.navigatedUrl) 
                                                  : (img.navigation == 2) ? dynamicFormPopup(img.catId) 
                                                  : (img.navigation == 3) ? scroll(item.customField35) 
                                                  : null" [src]="serverPath+img.img" [alt]="img.altImage || 'images'"
                              loading="lazy">
                          </div>
                          <!-- @if (item?.customField10 == 'Type 7') {
                        <div fxLayout="row" fxLayout.xs="column">
                          <div class="bottom-content">
                            <div fxFlex="50">
                              <h4 [style.font-size]="item.customField18"
                                [ngStyle.lt-md]="{ 'font-size': item.customField17 }"
                                style="text-align: left;padding-left: 20px;">{{
                                img.customField1 }}</h4>
                            </div>
                            <div fxFlex="50" fxLayoutAlign="end center">
                              @if (img.customField12) {
                              <button (click)="(img.navigation == 0) ? imageNavigation(img.catId) 
                                                      : (img.navigation == 1) ? link(img.navigatedUrl) 
                                                      : (img.navigation == 2) ? dynamicFormPopup(img.catId) 
                                                      : (img.navigation == 3) ? scroll(item.customField35) 
                                                      : null" [style.color]="'#ffffff'"
                                [style.border-radius]="img.customField11" class="primary padding-tb10 image-button">
                                {{img.customField12}}
                              </button>
                              }
                            </div>
                          </div>
                        </div>
                        } -->
                          @if (item?.customField10 !== 'Type 7') {
                          <div>
                            <div fxLayout="column">
                              @if (img.customField1 !== null) {
                              <span>
                                @if (img.customField1.length>0) {
                                <span fxLayoutAlign="space-evenly center" fxLayoutGap="5px">
                                  <p [style.font-size]="item.customField18"
                                    [ngStyle.lt-md]="{ 'font-size': item.customField17 }">
                                    {{
                                    img.customField1 }}
                                  </p>
                                </span>
                                }
                              </span>
                              }
                            </div>
                            <div fxLayout="column">
                              <div
                                [ngStyle]="{'display': img.customField12 && img.customField12.length === 0 ? 'none' : 'block'}">
                                @if (img.customField13==0) {
                                <div fxLayoutAlign="start center">


                                  @if (img.customField12) {
                                  <button (click)="(img.navigation == 0) ? imageNavigation(img.catId) 
                                                          : (img.navigation == 1) ? link(img.navigatedUrl) 
                                                          : (img.navigation == 2) ? dynamicFormPopup(img.catId) 
                                                          : (img.navigation == 3) ? scroll(item.customField35) 
                                                          : null" [style.color]="'#ffffff'"
                                    [style.border-radius]="img.customField11" class="primary padding-tb10"
                                    mat-flat-button>
                                    {{img.customField12}}
                                  </button>
                                  }
                                </div>
                                }
                                @if (img.customField13==1) {
                                <div fxLayoutAlign="center center">
                                  @if (img.customField12) {
                                  <button (click)="(img.navigation == 0) ? imageNavigation(img.catId) 
                                                          : (img.navigation == 1) ? link(img.navigatedUrl) 
                                                          : (img.navigation == 2) ? dynamicFormPopup(img.catId) 
                                                          : (img.navigation == 3) ? scroll(item.customField35) 
                                                          : null" [style.color]="'#ffffff'"
                                    [style.border-radius]="img.customField11" class="primary padding-tb10"
                                    mat-flat-button>
                                    {{img.customField12}}
                                  </button>
                                  }
                                </div>
                                }
                                @if (img.customField13==2) {
                                <div>
                                  @if (img.customField12) {
                                  <button fxFlex (click)="(img.navigation == 0) ? imageNavigation(img.catId) 
                                                          : (img.navigation == 1) ? link(img.navigatedUrl) 
                                                          : (img.navigation == 2) ? dynamicFormPopup(img.catId) 
                                                          : (img.navigation == 3) ? scroll(item.customField35) 
                                                          : null" [style.color]="'#ffffff'"
                                    [style.border-radius]="img.customField11" class="primary padding-tb10"
                                    mat-flat-button>
                                    {{img.customField12}}
                                  </button>
                                  }
                                </div>
                                }
                              </div>
                            </div>
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                    }
                    <!-- @if (img.type==1 && item?.customField10 == 'Type 3') {
                  <div fxLayoutAlign="center center">
                    <div fxFlex contentAnim [aniName]="img.customField7"
                      [ngClass]="{'border':item?.customField10=='Type 2', 'collection-banner': item.customField9==1}"
                      class="fast">
                      <div fxLayout="column">
                        <div fxLayout="column">
                          <div class="crosseffect"
                            (click)="img.navigation==0?imageNavigation(img.catId):link(img.navigatedUrl)">
                            <a>
                              <img width="100%" [style.height]="item.height" [ngStyle.lt-md]="{
                      'padding-top': i > 0 ? item.categoryId6 == 1 ? '10px' : 
                      i == 0 ? '10px' : '0px' : '0px',
                      'height': item.heightMob
                  }" [ngClass]="item.customField9==2 ? '' : 'collection-banner '" fxLayoutAlign="space-evenly stretch"
                                (click)="(img.navigation == 0) ? imageNavigation(img.catId) 
                                                    : (img.navigation == 1) ? link(img.navigatedUrl) 
                                                    : (img.navigation == 2) ? dynamicFormPopup(img.catId) 
                                                    : (img.navigation == 3) ? scroll(item.customField35) 
                                                    : null" [src]="serverPath+img.img" [alt]="img.altImage || 'images'"
                                loading="lazy">
                            </a>
                          </div>
                        </div>
                        <div fxLayout="column">
                          @if (img.customField1 !== null) {
                          <span>
                            @if (img.customField1.length>0) {
                            <span fxLayoutAlign="space-evenly center" fxLayoutGap="5px">
                              <p [style.font-size]="item.customField18"
                                [ngStyle.lt-md]="{ 'font-size': item.customField17 }">{{
                                img.customField1 }}
                              </p>
                            </span>
                            }
                          </span>
                          }
                        </div>
                        <div fxLayout="column">
                          <div
                            [ngStyle]="{'display': img.customField12 && img.customField12.length === 0 ? 'none' : 'block'}">
                            @if (img.customField13==0) {
                            <div fxLayoutAlign="start center">
                              @if (img.customField12) {

                              <button (click)="(img.navigation == 0) ? imageNavigation(img.catId) 
                                    : (img.navigation == 1) ? link(img.navigatedUrl) 
                                    : (img.navigation == 2) ? dynamicFormPopup(img.catId) 
                                    : (img.navigation == 3) ? scroll(item.customField35) 
                                    : null" [style.color]="'#ffffff'" [style.border-radius]="img.customField11"
                                class="primary padding-tb10" mat-flat-button>
                                {{img.customField12}}
                              </button>
                              }
                            </div>
                            }
                            @if (img.customField13==1) {
                            <div fxLayoutAlign="center center">
                              @if (img.customField12) {
                              <button (click)="(img.navigation == 0) ? imageNavigation(img.catId) 
                                                            : (img.navigation == 1) ? link(img.navigatedUrl) 
                                                            : (img.navigation == 2) ? dynamicFormPopup(img.catId) 
                                                            : (img.navigation == 3) ? scroll(item.customField35) 
                                                            : null" [style.color]="'#ffffff'"
                                [style.border-radius]="img.customField11" class="primary padding-tb10" mat-flat-button>
                                {{img.customField12}}
                              </button>
                              }
                            </div>
                            }
                            @if (img.customField13==2) {
                            <div>
                              @if (img.customField12) {
                              <button fxFlex (click)="(img.navigation == 0) ? imageNavigation(img.catId) 
                                    : (img.navigation == 1) ? link(img.navigatedUrl) 
                                    : (img.navigation == 2) ? dynamicFormPopup(img.catId) 
                                    : (img.navigation == 3) ? scroll(item.customField35) 
                                    : null" [style.color]="'#ffffff'" [style.border-radius]="img.customField11"
                                class="primary padding-tb10" mat-flat-button>
                                {{img.customField12}}
                              </button>
                              }
                            </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  } -->
                    <!-- @if (img.type==1 && item?.customField10 == 'Type 4') {
                  <div class="brighten" fxLayoutAlign="center center">
                    <div fxFlex contentAnim [aniName]="img.customField7"
                      [ngClass]="{'border':item?.customField10=='Type 2', 'collection-banner': item.customField9==1}"
                      class="fast brighten">
                      <div fxLayout="column" style="position: relative; cursor: pointer;">
                        <div fxLayout="column" class="brighten">
                          <div class="brighten" style="position: relative; cursor: pointer;">
                            <img width="100%" [style.height]="item.height" [ngStyle.lt-md]="{
                            'padding-top': i > 0 ? item.categoryId6 == 1 ? '10px' : i == 0 ? '10px' : '0px' : '0px',
                            'height': item.heightMob
                          }" [ngClass]="item.customField9==2 ? '' : 'collection-banner '"
                              fxLayoutAlign="space-evenly stretch"
                              (click)="img.navigation==0?imageNavigation(img.catId):link(img.navigatedUrl)"
                              [src]="serverPath+img.img" [alt]="img.altImage || 'images'" loading="lazy">
                            <div class="brighten"
                              style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                              <p style="color: white;" [style.font-size]="item.customField18"
                                [ngStyle.lt-md]="{ 'font-size': item.customField17 }">
                                {{ img.customField1 }}
                              </p>
                              <div>
                                <br>
                              </div>
                              <div
                                [ngStyle]="{'display': img.customField12 && img.customField12.length === 0 ? 'none' : 'block'}"
                                style="text-align: center;">
                                @if (img.customField13==0) {
                                <div style="display: inline-block;">
                                  @if (img.customField12) {
                                  <button (click)="(img.navigation == 0) ? imageNavigation(img.catId) 
                                          : (img.navigation == 1) ? link(img.navigatedUrl) 
                                          : (img.navigation == 2) ? dynamicFormPopup(img.catId) 
                                          : (img.navigation == 3) ? scroll(item.customField35) 
                                          : null" [style.color]="'#ffffff'" [style.border-radius]="img.customField11"
                                    class="primary padding-tb10" mat-flat-button>
                                    {{img.customField12}}
                                  </button>
                                  }
                                </div>
                                }
                                @if (img.customField13==1) {
                                <div style="display: inline-block;">
                                  @if (img.customField12) {
                                  <button (click)="(img.navigation == 0) ? imageNavigation(img.catId) 
                                          : (img.navigation == 1) ? link(img.navigatedUrl) 
                                          : (img.navigation == 2) ? dynamicFormPopup(img.catId) 
                                          : (img.navigation == 3) ? scroll(item.customField35) 
                                          : null" [style.color]="'#ffffff'" [style.border-radius]="img.customField11"
                                    class="primary padding-tb10" mat-flat-button>
                                    {{img.customField12}}
                                  </button>
                                  }
                                </div>
                                }
                                @if (img.customField13==2) {
                                <div style="display: inline-block;">
                                  @if (img.customField12) {
                                  <button fxFlex (click)="(img.navigation == 0) ? imageNavigation(img.catId) 
                                                            : (img.navigation == 1) ? link(img.navigatedUrl) 
                                                            : (img.navigation == 2) ? dynamicFormPopup(img.catId) 
                                                            : (img.navigation == 3) ? scroll(item.customField35) 
                                                            : null" [style.color]="'#ffffff'"
                                    [style.border-radius]="img.customField11" class="primary padding-tb10"
                                    mat-flat-button>
                                    {{img.customField12}}
                                  </button>
                                  }
                                </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  } -->
                    <!-- @if (img.type==1 && item?.customField10 == 'Type 6') {
                  <div class="brighten" fxLayoutAlign="center center">
                    <div fxFlex contentAnim [aniName]="img.customField7"
                      [ngClass]="{'border':item?.customField10=='Type 2', 'collection-banner': item.customField9==1}"
                      class="fast brighten">
                      <div fxLayout="column" style="position: relative; cursor: pointer;">
                        <div fxLayout="column" class="brighten">
                          <div class="newimg" (click)="popupDialog(serverPath+img.img)"
                            style="position: relative; cursor: pointer;">
                            <img width="100%" [style.height]="item.height" [ngStyle.lt-md]="{
                        'padding-top': i > 0 ? item.categoryId6 == 1 ? '10px' : i == 0 ? '10px' : '0px' : '0px',
                        'height': item.heightMob
                      }" [ngClass]="item.customField9==2 ? '' : 'collection-banner '"
                              fxLayoutAlign="space-evenly stretch"
                              (click)="img.navigation==0?imageNavigation(img.catId):link(img.navigatedUrl)"
                              [src]="serverPath+img.img" [alt]="img.altImage || 'images'" loading="lazy">
                           
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  } -->
                    @if (img.type==3) {
                    <div>
                      <div contentAnim [aniName]="img.customField7" class="fast">
                        <calsoft-vedio-layout fxFlex="100" [index]="i" [item]="item" [img]="img">
                        </calsoft-vedio-layout>
                      </div>
                    </div>
                    }
                    <!-- @if (img.type==4) {
                  <div fxFlex="100" fxLayoutAlign="center center">
                    <div fxFlex contentAnim [aniName]="img.customField7"
                      [ngClass]="{'border':item?.customField10=='Type 2', 'collection-banner': item.customField9==1}"
                      class="fast">
                      <calsoft-image-over-content [index]="i" [item]="item" [img]="img">
                      </calsoft-image-over-content>
                    </div>
                  </div>
                  } -->
                    <!-- @if (img.type==12) {
                  <div fxFlex="100" fxLayoutAlign="center center">
                    <div fxFlex contentAnim [aniName]="img.customField7"
                      [ngClass]="{'border':item?.customField10=='Type 2', 'collection-banner': item.customField9==1}"
                      class="fast">
                      <calsoft-image-over-content2 [index]="i" [item]="item" [img]="img">
                      </calsoft-image-over-content2>
                    </div>
                  </div>
                  } -->
                    <!-- @if (img.type==5) {
                  <div fxFlex="100">
                    <calsoft-image-card [index]="i" [item]="item" [img]="img"></calsoft-image-card>
                  </div>
                  } -->
                    <!-- @if (img.type==6) {
                  <div fxFlex="100" fxLayoutAlign="center center">
                    <calsoft-lookback fxFlex="100" [data]="data" [index]="i" [item]="item" [img]="img">
                    </calsoft-lookback>
                  </div>
                  } -->
                    <!-- @if (img.type==7) {
                  <div fxFlex="100" fxLayoutAlign="center center">
                    <div fxFlex="100"
                      [ngClass]="{'border':item?.customField10=='Type 2', 'collection-banner': item.customField9==1}"
                      class="fast">
                      <calsoft-image-text-with-button fxFlex="100" [data]="data" [index]="i" [item]="item"
                        [img]="img"></calsoft-image-text-with-button>
                    </div>
                  </div>
                  } -->
                    @if (img.type==8 && item?.customField10 != 'Type 8' && img.customField33!=11) {
                    <div fxFlex="100" fxLayoutAlign="center start" style="align-items:start;">
                      <div fxFlex="100">
                        <calsoft-mobileicon [data]="data" [index]="i" [item]="item" [img]="img">
                        </calsoft-mobileicon>
                      </div>
                    </div>
                    }
                    <!-- @if (img.type==9 ) {
                  <div fxFlex="100" fxLayoutAlign="center center">
                    <div fxFlex="100"
                      [ngClass]="{'border':item?.customField10=='Type 2', 'collection-banner': item.customField9==1}"
                      class="fast">
                      <calsoft-image-text fxFlex="100" [data]="data" [index]="i" [item]="item"
                        [img]="img"></calsoft-image-text>
                    </div>
                  </div>
                  } -->
                    <!-- @if (img.type==8 && img.customField33==11 ) {
                  <div fxFlex="100" fxLayoutAlign="center center">
                    <div fxFlex="100">
                      <calsoft-iconflow fxFlex="100" [data]="data" [index]="i" [item]="item" [img]="img"
                        [totalItems]="item.images.length"></calsoft-iconflow>
                    </div>
                  </div>
                  } -->
                    <!-- @if (img.type==10) {
                  <div fxFlex="100" fxLayoutAlign="center center">
                    <div fxFlex="100"
                      [ngClass]="{'border':item?.customField10=='Type 2', 'collection-banner': item.customField9==1}"
                      class="fast">
                      <calsoft-scroll-image fxFlex="100" [data]="data" [index]="i" [item]="item"
                        [img]="img"></calsoft-scroll-image>
                    </div>
                  </div>
                  } -->
                    <!-- @if (img.type==11) {
                  <div fxFlex="100" fxLayoutAlign="center center">
                    <div fxFlex="100"
                      [ngClass]="{'border':item?.customField10=='Type 2', 'collection-banner': item.customField9==1}"
                      class="fast">
                      <calsoft-price-plan fxFlex="100" [data]="data" [index]="i" [item]="item"
                        [img]="img"></calsoft-price-plan>
                    </div>
                  </div>
                  } -->
                  </div>
                  }
                </div>
              </div>
              <!-- @if (item?.customField10 == 'Type 8') {
            <div>
              <calsoft-image-zigzag-text fxFlex="100" [data]="data" [img]="item.images" [index]="i" [item]="item"
                [img]="img"></calsoft-image-zigzag-text>
            </div>
            } -->
            </div>
          </div>
          }
          <div [ngClass]="i>0 ? 'margin-t11' : ''">
            @if (item.type=='textwithform' && (item.layout == '0' || item.layout == '1') ) {
            <div class="container">
              <div [fxLayout.gt-md]="item.customField3=='left'?'row':'row-reverse'" fxLayout.xs="column"
                [style.backgroundImage]="'url(' + serverPath+item.customField24 + ')'"
                [style.background-color]="item.customField37">
                <div fxFlex="50" fxFlex.xs="100">
                  <calsoft-image-contact-form [item]="item" [data]="data" [img]="item.images">
                  </calsoft-image-contact-form>
                </div>
                <!-- <div *ngIf="item.customField3!='left'" fxFlex="5">
                </div> -->
                <!-- <span style="border-right: 1px solid lightgray; padding: 25px "></span> -->
                <!-- <div *ngIf="item.customField3=='left'" fxFlex="5">
              </div> -->
                <div fxFlex="50" fxFlex.xs="100" fxLayout="column"
                  [ngStyle.gt-md]="{ 'align-items': item.customField33, 'justify-content': item.customField33 }"
                  style="display: flex; ">
                  <div style="background-color:white; margin: 10px;">
                    <calsoft-contact-form [data]="data" [item]="item" [input]="item.title">
                    </calsoft-contact-form>
                  </div>
                </div>
              </div>
            </div>
            }
            @if (item.type=='textwithform' && item.layout == '2' ) {
            <div class="container">
              <div class="formcss" [fxLayout.gt-md]="item.customField3=='left'?'row':'row-reverse'"
                fxLayout.xs="column">
                <div fxFlex fxFlex.xs="100">
                  <calsoft-image-contact-form [data]="data" [item]="item" [img]="item.images">
                  </calsoft-image-contact-form>
                </div>
                <div fxFlex fxFlex.xs="100">
                  <calsoft-contact-form [data]="data" [item]="item" [input]="item.title">
                  </calsoft-contact-form>
                </div>
              </div>
            </div>
            }
          </div>
          @if (item.type=='TextAnimationwithtext') {
          <div [ngClass]="i>0 ? 'margin-t11' : ''">
            @if (item.customField17==0) {
            <div>
              <calsoft-animated-text [item]="item" [img]="item.images" [data]="data"></calsoft-animated-text>
            </div>
            }
          </div>
          }
          @if (item.type=='faq') {
          <div [ngClass]="i>0 ? 'margin-t11' : ''">
            @if (item.customField25!='2') {
            <div class="container">
              <calsoft-faq [item]="item" [data]="data" [faq]="item.images"></calsoft-faq>
            </div>
            }
            @if (item.customField25=='2') {
            <div [fxLayout.gt-md]="item.customField3=='left'?'row':'row-reverse'" fxLayout="row" fxLayout.xs="column"
              class="container">
              <div fxFlex="50" fxLayout="column">
                <div>
                  <img width="100%" [style.height]="item.height" [ngStyle.lt-md]="{'height': item.heightMob}"
                    [src]="serverPath+item.customField6" [alt]="item.altImage || 'images'" />
                </div>
              </div>
              <div fxFlex="50" fxLayout="column" [ngStyle]="{'margin-left': item.gapBetweenImage}">
                <calsoft-faq [item]="item" [faq]="item.images"></calsoft-faq>
              </div>
            </div>
            }
          </div>
          }
          <!-- @if (item.type=='footer') {
        <div [ngClass]="i>0 ? 'margin-t11' : ''">
          <calsoft-footerlayout [item]="item" [data]="data" [img]="item.images"></calsoft-footerlayout>
        </div>
        } -->
          <div [ngClass]="i>0 ? 'margin-t11' : ''">
            @if (item.type=='freeText') {
            <div>
              <div [class.space]="item.customField8.length>0" class="bg-image"
                [style.backgroundImage]="'url(' + serverPath+item.customField6 + ')'"
                [style.background-color]="item.customField8" [ngClass]="item.customField23 ? 'centercss' :'' "
                fxLayout="row" fxLayoutGap="5px" [style.border-radius]="item.customField24"
                [fxFlex]="(item.customField23) ? item.customField23 : 100"
                [fxFlex.lt-md]="(item.customField28) ? item.customField28 : ''">
                <div fxFlex="100" fxLayout="row" class="container">
                  <div fxFlex="100" fxLayout="row">
                    <div fxFlex="100" fxLayout="column">
                      @if (item.customField25 !=1 || item.customField25 != '1' ) {
                      <div>
                        @if (item.customField27=='Center') {
                        <div fxFlex="100" fxLayoutAlign="center center"
                          [ngStyle]="{'font-family': item.fontFamily || 'cursive', 'color': item.customField26 || 'black'}"
                          contentAnim [aniName]="item.customField7" [style.font-size]="item.customField18"
                          [ngStyle.lt-md]="{ 'font-size': item.customField17,
                'font-family': item.fontFamily || 'cursive'
               }" [style.font-weight]="item.customField29" class="textwithImage">
                          <calsoft-editor-text [data]="data" [id]="item.customField35" [text]="item?.title"
                            [align]="item.customField34">
                          </calsoft-editor-text>
                        </div>
                        }
                        @if (item.customField27=='Left') {
                        <div fxFlex="100" fxLayoutAlign="start center"
                          [ngStyle]="{'font-family': item.fontFamily || 'cursive', 'color': item.customField26 || 'black'}"
                          contentAnim [aniName]="item.customField7" [style.font-size]="item.customField18"
                          [ngStyle.lt-md]="{ 'font-size': item.customField17,
            'font-family': item.fontFamily || 'cursive'
           }" [style.font-weight]="item.customField29" class="textwithImage">
                          <calsoft-editor-text [data]="data" [id]="item.customField35" [text]="item?.title"
                            [align]="item.customField34">
                          </calsoft-editor-text>
                        </div>
                        }
                        @if (item.customField27=='scroll') {
                        <!-- <div [ngClass]="i>0 ? 'margin-t11' : ''">
                          <calsoft-marqeedesign fxFlex="100" [img]="item.images" [index]="i" [item]="item" [img]="img">
                          </calsoft-marqeedesign>
                        </div> -->
                        }

                      </div>
                      }

                      @if (item.categoryId6==1) {
                      <div>
                        <div fxFlex="100" fxLayoutAlign="start center">
                          <calsoft-editor-text [data]="data" [id]="item.customField35" [text]="item?.customField1"
                            [align]="item.customField34" [ngStyle.gt-md]="{'font-size': item.customField18 }"
                            [ngStyle.lt-md]="{
                                                      
                                                      'font-size': item.customField17
                                                  }">
                          </calsoft-editor-text>
                        </div>
                      </div>
                      }
                      @if (item.categoryId6==0) {
                      <div>
                        <div fxFlex="100" fxLayoutAlign="center center">
                          <calsoft-editor-text [data]="data" [id]="item.customField35" [text]="item?.customField1"
                            [fontFamily]="item.fontFamily" [ngStyle.gt-md]="{'font-size': item.customField39 }"
                            [ngStyle.lt-md]="{
                                                  
                                                   'font-size': item.customField40
                                              }" [align]="item.customField34">
                          </calsoft-editor-text>
                        </div>
                      </div>
                      }
                    </div>
                    @if (item.customField30 && item.customField30.length>0) {
                    <div fxLayoutAlign="center center">
                      <a mat-raised-button href="{{item.customField32}}" [style.background-color]="item.customField31"
                        target="_blank" style="color: white;border-radius: 30px;">{{item.customField30}}
                        @if (item.customField33) {
                        <mat-icon>{{item.customField33}}</mat-icon>
                        }
                      </a>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
        @if (type==1) {
        <div class="search-results" style="height: 0px;" infiniteScroll
          [infiniteScrollDistance]="isLowEndMobile ? 6 : (mobileLayoutTwo ? 4 : 2)"
          [infiniteScrollThrottle]="isLowEndMobile ? 800 : (mobileLayoutTwo ? 500 : 150)" (scrolled)="onScroll()">
          @if (spinner !=false) {
          <div fxLayout=row fxLayoutAlign="center center">
            @if (page <pageSize) { <mat-progress-spinner></mat-progress-spinner>
              }
          </div>
          }
        </div>
        }
        @if (type==2&&pageNated) {
        <div>

          <div class="search-results" style="height: 0px;" infiniteScroll
            [infiniteScrollDistance]="isLowEndMobile ? 5 : (mobileLayoutTwo ? 4 : 2)"
            [infiniteScrollThrottle]="isLowEndMobile ? 600 : (mobileLayoutTwo ? 400 : 150)" (scrolled)="onScroll()">
            @if (spinner !=false) {
            <div fxLayout=row fxLayoutAlign="center center">
              @if (page <pageSize) { <mat-progress-spinner></mat-progress-spinner>
                }
            </div>
            }
          </div>
        </div>
        }
      </div>
      }
    </div>

  </div>
</div>